<template>
    <div class="hero__content" :class="{'hero__content--video' : hero_is_video}">
        <div class="hero__text" :class="{'display-none' : extra_class_2025_2eur }">
            <OfferBoxCashback offer="2€ / 2 mois"></OfferBoxCashback>
            <div class="text">
                <p class="pretitle">Découvrez Testachats et</p>
                <p class="title">cet Airfryer <span class="accent">GRATUIT</span> <br>
                    en cadeau</p>
            </div>
        </div>
        <div class="hero_img_container">
            <video autoplay muted loop class="hero__deco hero__deco--video" v-if="hero_is_video" >
                <source :src="home_hero_desktop_video" type="video/mp4">
            </video>
            <img v-else class="hero__deco" :src="home_hero_desktop_image"
                 :alt="home_hero_alt">
        </div>
    </div>
</template>

<script>
import image_mixin from "../../_commons/fr/mixins/image_mixin";
import OfferBoxCashback from "../../_commons/fr/newComponents/OfferBoxCashback.vue";

export default {
    name: "HomeHero",
    components: {OfferBoxCashback},
    mixins: [
        image_mixin
    ]
}
</script>

<style scoped>
.display-none {
    display: none;
}
</style>
